//@flow
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory } from 'react-router';
import CookiesData from '../Utils/cookies-data';
import '../Stores/Heap/heapStore';
import '../Stores/Experiments/experimentsStore';
import SessionActions from '../Actions/session';
import ExperimentsActions from '../Actions/experiments';
import CartActions from '../Actions/cart';
import AccountActions from '../Actions/account';
import HeapActions from '../Actions/heap';
import FriendBuyV2 from './friendbuyV2';
import UrlData from '../Utils/url-data';

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'development') {
  const axe = require('react-axe');
  axe(React, ReactDOM, 1000);
}

function _setupPage() {
  // set global.inServer to false (make api calls);
  window.inServer = false;
  // Grab window dimensions and apply to heap
  HeapActions.initializeSession({
    innerWidth: window ? window.innerWidth : 0,
    innerHeight: window ? window.innerHeight : 0,
  });

  // Grab url query string and set in cookie for potential
  // use in future operations (e.g. submitting office form).
  // This way we can keep track of the url query params that
  // a user had when they first arrived at site without needing
  // to pass query string in all links
  CookiesData.setInitialQueryData(UrlData.getSearch());

  // load friendbuy
  FriendBuyV2.loadFriendbuy();

  const userData = CookiesData.getUser();

  if (userData) {
    SessionActions.loginFromData(userData);
  }

  const softLinkToken = UrlData.getSoftLinkToken();
  const magicLinkToken = UrlData.getMagicLinkToken();

  if (magicLinkToken) {
    SessionActions.loginWithMagicLink(magicLinkToken);
  } else if (softLinkToken) {
    SessionActions.loginWithSoftLink(softLinkToken);
  }

  // TODO: investigate why setting the cart open before rendering causes scrolling issues (react-sidebar)
  if (UrlData.getOpenCart()) setTimeout(() => {
    CartActions.openCartPreview();
    UrlData.removeParamAndUpdateHistory('open_cart');
  }, 0);

  window.addEventListener('load', () => setTimeout(_measureTiming, 0));

  // expose the experiment actions for optimizely to use
  window.naturebox.experiments = ExperimentsActions;

  if (UrlData.shouldOpenPasswordModal()) AccountActions.openPasswordModal();

  return userData;
}

function _measureTiming() {
  const timing = window && window.performance && window.performance.timing;
  if (!timing) return;
  const heapData = {};
  heapData['dom_interactive'] = (timing.domInteractive - timing.connectStart);
  heapData['dom_loaded'] = (timing.domComplete - timing.connectStart);
  HeapActions.trackPagePerformance(heapData);
}

export default function renderPage(routes:React$Element<*>) {
  _setupPage();

  const reactRoot = window.document.getElementById('react-root');
  const element = React.createElement(Router, {
    routes,
    history: browserHistory,
  });
  ReactDOM.render(element, reactRoot);
}
